import { render, staticRenderFns } from "./assign.vue?vue&type=template&id=79d3615e"
import script from "./assign.vue?vue&type=script&lang=js"
export * from "./assign.vue?vue&type=script&lang=js"
import style0 from "./assign.vue?vue&type=style&index=0&id=79d3615e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports